import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EUniversity = {
  title: {
    name: ['دانشگاه', 'دانشگاه ها'],
  },
  routes: PATH_DASHBOARD.university,
  api: api.university,
  enum: {
    array: Object.values(travelTypeObject),
    object: travelTypeObject,
  },
};

export default EUniversity;
